import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import moment from "moment";
import Constants from "../business/Constants";
import Tracker from "../business/Tracker";

class AreaPersonaleCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.numberReg =  /^[0-9]+$/;
        this.init();
    }
    init() {
        this.loadChildComponents(this);
         this.startLoader();
        GigyaManager.getLoggedUserCached().then((u) => {
            let name = u.profile.firstName;
            let gender = u.profile.gender;
            let msg = $(".custom-msg");
            if (gender === "f"){
                $(msg).html("Benvenuta " + name);
            } else if (gender === "m") {
                $(msg).html("Benvenuto " + name);
            } else {
                $(msg).html("Ciao " + name);
            }

            try{
              Tracker.send("EVENT", {gravitante: true})
            }catch (err){
                console.log("Error on tracker...")
            }

            RestManager.userStatus().then((resp)=>{

                let contest = resp.response.data.contests[0];
                if(contest.plays_stats.points_left == 1){
                    $('#points_text').html(contest.plays_stats.points_left + " punto")
                }else{
                    $('#points_text').html(contest.plays_stats.points_left + " punti")
                }

                if(contest.plays_stats.points_left >= 4){
                    $('#requestCollectionPrizeBox').show();
                }


                let isPhoneNumberComplete = contest.user_profile.phone_number_completed;

                if(!isPhoneNumberComplete){
                    $('#associaTelefono').show();
                }else{
                    let tel = contest.user_profile.phone_number_msisdn;
                    $('#telefonoAssociato .tel').html(tel);
                    $('#telefonoAssociato').show();
                }

                let activities = contest.plays.map(obj => {obj["type"]="code"; return obj;});

                if(contest.prizes_list && contest.prizes_list.length > 0){
                    activities = activities.concat(contest.prizes_list.map(obj => {obj["type"]="prizeRequest"; return obj;}))
                }

                activities.sort((a,b) =>{
                    a = a.type == "code" ? moment(a.istant_win.play_date, "YYYY-MM-DD hh:mm:ss").toDate()  : moment(a.shipment.user.user_requested_date, "DD/MM/YY hh:mm:ss").toDate();
                    b = b.type == "code" ? moment(b.istant_win.play_date, "YYYY-MM-DD hh:mm:ss").toDate() : moment(b.shipment.user.user_requested_date, "DD/MM/YY hh:mm:ss").toDate();
                    return a > b ? -1 : a < b ? 1 : 0;
                })

                console.log(contest);

                let activityListHtml = "";
                for(var i = 0; i < activities.length; i++){
                    let activity = activities[i];
                    if(activity.type == "code"){
                        activityListHtml += this.buildPlayCodeTemplate(activity);
                    } else if (activity.type == "prizeRequest"){
                        activityListHtml += this.buildBagPrizeRequest(activity.shipment);
                    }
                }

                $('#activity-list').html(activityListHtml);

                this.removeLoader();
            }, (err) =>{
                let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>${err.status.errors.description}<br/><br/> Ci scusiamo per il disagio riprova più tardi!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
                $(this.element).append(tmplModalGeneric);
                this.loadChildComponents(this);
                this.removeLoader();
            })


        }, (err) => {
            window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
        })
    }

    goToPlayCode(){
        window.location.href='/promozioni/il-divertimento-e-fuori/gioca-codice'
    }

    buildPlayCodeTemplate(obj){

        let mm_play_date = moment(obj.istant_win.play_date, "YYYY-MM-DD hh:mm:ss");
        mm_play_date.locale('it');

        let icon = "https://static.mulinobianco.it/pew/KIDS_2019/assets/img/punto-omaggio.png";
        switch(obj.istant_win.code.description){
            case "Focaccelle":
                icon = "https://static.mulinobianco.it/pew/KIDS_2019/assets/img/punto-focaccelle.png";
                break;
            case "Pane+Cioccolato":
                icon = "https://static.mulinobianco.it/pew/KIDS_2019/assets/img/punto-panecioccolato.png";
                break;
            case "Flauti":
                icon = "https://static.mulinobianco.it/pew/KIDS_2019/assets/img/punto-flauti.png";
                break;
            case "Pan Goccioli":
                icon = "https://static.mulinobianco.it/pew/KIDS_2019/assets/img/punto-pangocciolo.png"
                break;
        }

        let html = `
            <div class="wrap-attivitaSingola">
                    ${this.buildIWPrizeRequest(obj)}
                    <div class="attivitaSingola">
                        <figure>
                            <img src="${icon}">
                        </figure>
                        <div class="attivita-contenuto">
                            <span class="date">
                                ${mm_play_date.format("DD MMMM YYYY")}
                            </span>
                            <span class="punti">
                                ${parseInt(obj.istant_win.code.points) > 1 ? '+'+obj.istant_win.code.points+' punti': '+'+obj.istant_win.code.points+' punto'}
                            </span>
                            <span class="description">
                                Hai giocato un codice <strong class="nome-prodotto">${obj.istant_win.code.description}</strong> e guadagni
                                <strong class="punti-guadagnati"> ${parseInt(obj.istant_win.code.points) > 1 ? obj.istant_win.code.points+' punti': obj.istant_win.code.points+' punto'}</strong>!
                            </span>
                        </div>
                    </div>
                </div>
        `;
        return html;
    }

    buildBagPrizeRequest(shipment){
        let mm_play_date = moment(shipment.user.user_requested_date, "DD/MM/YY hh:mm:ss");
        mm_play_date.locale('it');
        let html = `<div class="wrap-attivitaSingola">
                    <div class="richiedi-premio">
                        <figure>
                        <img src="https://static.mulinobianco.it/pew/KIDS_2019/assets/img/premio-attivita-zaino.png">
                        </figure>
                        <div class="content">
                        <span class="date">
                            ${mm_play_date.format("DD MMMM YYYY")}
                        </span>
                        <h3>Grande!</h3>
                        <p>Hai richiesto lo <strong>Zainetto!</strong></p>
                    </div>
                    <div class="content-details">
                        <p>Nome e cognome: <strong>${shipment.user.user_first_name} ${shipment.user.user_last_name}</strong><br/>
                        Indirizzo: <strong>${shipment.user.user_address}, ${shipment.user.user_house_number} ${shipment.user.user_city}(${shipment.user.user_province}), ${shipment.user.user_zip_code}</strong><br/>
                        ${shipment.user.user_intercom ? 'Citofono: <strong>'+shipment.user.user_intercom +'</strong><br/>': ''}
                        ${shipment.shipment_date ? 'Stato evasione: <strong>Spedito il '+shipment.shipment_date+'</strong><br/>': ''}
                        ${shipment.shipment_link ? ' Segui la spedizione: <strong>'+shipment.shipment_link+'</strong></p>' :''}
                    </div>
            </div>`;
        return html;

    }

    buildIWPrizeRequest(activity){
        let html = '';
        if(activity.istant_win.win_status == "WIN") {
            let mm_play_date = moment(activity.istant_win.play_date, "YYYY-MM-DD hh:mm:ss");
            mm_play_date.locale('it');
            if (activity.istant_win.prize_request.requested == 0) {
                html = `<div class="richiedi-premio">
                        <figure>
                            <img src="https://static.mulinobianco.it/pew/KIDS_2019/assets/img/premio-attivita-monopattino.png">
                        </figure>
                        <div class="content">
                            <span class="date">
                                 ${mm_play_date.format("DD MMMM YYYY")}
                            </span>
                            <h3>Grande!</h3>
                            <p>Hai vinto il <strong>Monopattino Razor!</strong></p>
                        </div>
                        <div class="content-details">
                        </div>
                    </div>`;
            } else {
                let shipment = activity.istant_win.shipment;
                html = `<div class="wrap-attivitaSingola">
                    <div class="richiedi-premio">
                        <figure>
                        <img src="https://static.mulinobianco.it/pew/KIDS_2019/assets/img/premio-attivita-monopattino.png">
                        </figure>
                        <div class="content">
                        <span class="date">
                            ${mm_play_date.format("DD MMMM YYYY")}
                        </span>
                        <h3>Grande!</h3>
                        <p>Hai richiesto il <strong>Monopattino Razor!</strong></p>
                    </div>
                    <div class="content-details">
                        <p>Nome e cognome: <strong>${shipment.user.user_first_name} ${shipment.user.user_last_name}</strong><br/>
                        Indirizzo: <strong>${shipment.user.user_address}, ${shipment.user.user_house_number} ${shipment.user.user_city}(${shipment.user.user_province}) ${shipment.user.user_zip_code}</strong><br/>
                        ${shipment.user.user_intercom ? 'Citofono: <strong>'+shipment.user.user_intercom +'</strong><br/>': ''}                        
                        ${shipment.shipment_date ? 'Stato evasione: <strong>Spedito il '+shipment.shipment_date+'</strong><br/>': ''}
                        ${shipment.shipment_link ? ' Segui la spedizione: <strong>'+shipment.shipment_link+'</strong></p>' :''}
                    </div>
            </div>`
            }
        }
        return html;
    }


    async openAssociaTelModal(){
       let u = await GigyaManager.getLoggedUserCached();
       var ch = u.data[Constants.CH_PROMO];
       let regAcceptance = typeof ch !== "undefined" && ch != null && ch != "";
       let modal = `
            <div class="feedback__modal" component="FeedbackModalComponent" id="modalAssociaTelefono">
                <div class="feedback__modal__wrap">
                    <div class="feedback__modal__close" component-click="close()">
                        <svg>
                            <use xlink:href="#svg_circle_close"></use>
                        </svg>
                    </div>
                    <div class="feedback__modal__content">
                        <h2>Associa il tuo numero di cellulare</h2>
                        <p>Associa subito al tuo profilo il tuo cellulare. In questo modo, se partecipi via sms,<br/>
                            troverai automaticamente memorizzati nella tua area personale i punti accumulati.<br/>
                            Ricordati di partecipare via sms sempre con il cellulare che hai associato.<br/>
                            Se hai già giocato uno o più codici via SMS, troverai qui i punti accumulati.</p>
                        <div class="main-form">
                            <form id="kids2019_form_numero" action="" method="get">
                                <!--prodotto-->
                                <div class="row-form row-form--dati content-align-center">
                                    <div class="col-form col-form--50">
                                    	<label for="associaTelefono"><span class="small">Inserisci il numero di telefono senza il prefisso +39 o 0039</span></label>
                                        <input type="text" name="telefono" id="telefono" placeholder="Numero di cellulare" autocomplete=“off”
                                               tabindex="1" maxlength="12">
                                        <span class="error-feedback"></span>
                                    </div>
                                </div>
                                ${regAcceptance ? '' : '<div class="row-form row-form--dati custom-row--acceptance content-align-center" ><div class="col-form" id="regulationAcceptance"> <input tabindex="13" type="checkbox" name="acceptance" id="acceptance" value="accetto"> <label for="acceptance">Dichiaro di essere maggiorenne e di accettare il <a href="/promozioni/il-divertimento-e-fuori/regolamento" target="_blank">regolamento</a> del concorso</label> </div> </div>'}
                               
                                <div class="row-form row-form--dati content-align-center">
                                    <div class="col-form col-form--50">
                                        <a class="button button__confirm" id="conferma" tabindex="2" component-click="submitAssociateTelephoneForm()">Salva il numero</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
       `;
        $('.mb-promo-kids-2019').append(modal);
        $('#kids2019_form_numero #conferma').click(()=>{this.submitAssociateTelephoneForm()})
       this.loadChildComponents(this);

    }

    removeLoader(){
        $('.tool_loader').fadeOut(500).remove();
        $('body').removeClass('noScroll');
    }

    startLoader(){
        $('.mb-promo-kids-2019').append('<div data-tool-loader="" class="tool_loader" style="z-index:99999999;"><svg><use xlink:href="#svg_loader"></use></svg></div>');
        $('body').addClass('noScroll');
    }

    take_acceptance(){
        if( $('#acceptance').length ){
            if($('#acceptance').prop("checked") == false){
                $('#acceptance').addClass('error');
                $('.custom-row--acceptance').append('<span class="error-feedback"><span class="icon-error">!</span> Attenzione! Devi aver letto e accettato il regolamento.</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_telefono(){
        if( $('#telefono').length ){
            var telefono = $('#telefono').val();
            if (telefono.length < 2 & telefono !== undefined) {
                $('#telefono').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
                return false;
            } else {
                var validTel = this.numberReg.test(telefono);
                if (!validTel) {
                    $('#telefono').addClass('error').after('<span class="error-feedback"><span' +
                        ' class="icon-error">!</span> Il campo deve essere composto' +
                        ' solo da' +
                        ' caratteri numerici</span>');
                    return false;
                }else{
                    return true;
                }

            }
        } else {
            return true;
        }
    }

    submitAssociateTelephoneForm(){
        console.log("Submit form...")
        if(!$('#conferma').prop("disabled")) {
            $('#conferma').prop("disabled", true);
            this.startLoader();
            $('.error-feedback').remove();
            $('input, select').removeClass('error');
            let validTel = this.take_telefono();
            let validAccpt = this.take_acceptance();
            if(validTel && validAccpt){
                let tel = $('#telefono').val();
                if($('#acceptance').length){
                    GigyaManager.addCH(Constants.CH_PROMO).then(()=>{
                        this.doAssociateTelephoneCall(tel)
                    }, ()=>{
                        this.removeLoader();
                        $('#conferma').prop("disabled", false);
                    })
                }else{
                    this.doAssociateTelephoneCall(tel);
                }
            }else{
                this.removeLoader();
                $('#conferma').prop("disabled", false);
            }
        }
    }

    doAssociateTelephoneCall(tel){
        RestManager.associateTelephone(tel).then(()=>{
            window.location.reload();
        }, (err)=>{
            let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>${err.status.errors.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
            $(this.element).append(tmplModalGeneric);
            this.loadChildComponents(this);
            $('#conferma').prop("disabled", false);
            this.removeLoader();
        });
    }




}

export default AreaPersonaleCtrl;
